import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutrasReceitasAppRoutingModule } from './outras-receitas.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OutrasReceitasAppRoutingModule
  ]
})
export class OutrasReceitasAppModule { }
